import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { bgLinearGradient } from "@/app/types/ui";
import { RegisterProfessionalDataForm } from "@/components/register/beta/RegisterProfessionalDataForm";
import { LanguageSelector } from "@/components/shared/LanguageSelector";
import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { ParagraphBold } from "@/components/ui/typography/ParagraphBold";

import loginImg from "@/assets/login/login-img.png";

export const Route = createFileRoute("/register/beta/professional")({
  component: ProfessionalData,
});

function ProfessionalData() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-5 min-h-screen max-h-screen overflow-y-hidden">
      {/* Image */}
      <div className="grid col-span-2 bg-beige self-center overflow-y-hidden">
        <img src={loginImg} alt="Login img" />
      </div>

      {/* Professional Data Form */}
      <div
        className={`grid col-span-3 ${bgLinearGradient} border-l-1 border-neutral-500 overflow-y-auto max-h-screen [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-beige [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-neutral-100`}
      >
        <div>
          <div className="my-8 flex justify-end mx-24 2xl:max-w-3xl 2xl:mx-auto">
            <LanguageSelector />
          </div>
          <div className="flex flex-col my-auto mt-4 justify-center xl:h-5/6">
            <div className="mx-auto mb-8">
              <MimiatHorizontalLogo />
            </div>
            <div className="mx-24 2xl:min-w-[575px] 2xl:mx-auto mb-12">
              <div className="flex flex-col gap-2 mb-4">
                <div className="flex gap-3 items-baseline">
                  <HeadingOne>{t("register.professional.title")} </HeadingOne>
                  <ParagraphBold>
                    {t("register.professional.step")}
                  </ParagraphBold>
                </div>
                <Paragraph>{t("register.professional.subtitle")}</Paragraph>
              </div>
              <RegisterProfessionalDataForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
